/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePendingSendSummary } from '../../models/api-response-pending-send-summary';

export interface GetSendStatus$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  since?: string;
}

export function getSendStatus(http: HttpClient, rootUrl: string, params: GetSendStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePendingSendSummary>> {
  const rb = new RequestBuilder(rootUrl, getSendStatus.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('since', params.since, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePendingSendSummary>;
    })
  );
}

getSendStatus.PATH = '/v1/api/pending-messages/send-status';
